import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  managers: [],
  loading: false,
  error: null,
};

const managersSlice = createSlice({
  name: "managers",
  initialState,
  reducers: {
    // Set managers data
    setManagers: (state, action) => {
      state.managers = action.payload || [];
      state.loading = false;
      state.error = null;
    },

    

    // Set loading state
    setManagersLoading: (state, action) => {
      state.loading = action.payload;
    },

    // Set error state
    setManagersError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    // Clear error state
    clearManagersError: (state) => {
      state.error = null;
    },

    // Update manager SMAs
    updateManagerSMAs: (state, action) => {
      const responseData = action.payload;
      
      // Handle both fund (for new_sma) and sma (for update_sma)
      const smaData = responseData?.sma || responseData?.fund;
      
      if (smaData && state.managers.length > 0) {
        const { smaId } = smaData;
        
        const smaForManager = {
          [smaId]: smaData
        };
        
        // Add or update in managers[0].smas
        state.managers[0].smas = {
          ...state.managers[0].smas,
          ...smaForManager
        };
      }
    },

    // Blacklist functions - regular reducers like other functions
    blacklistRulesManager: (state, action) => {
      // Handle blacklistRulesManager logic here
      const { manager, blacklist } = action.payload;
      const managerIndex = state.managers.findIndex(
        (i) => i.managerId === manager?.managerId
      );
      if (managerIndex !== -1) {
        state.managers[managerIndex] = {
          ...state.managers[managerIndex],
          blacklist: blacklist,
        };
      }
    },

    blacklistRulesModifiedManager: (state, action) => {
      const { blacklist } = action.payload;
      const managerIndex = state.managers.findIndex(
        (i) => i.managerId === blacklist?.managerId
      );

      if (managerIndex !== -1) {
        state.managers[managerIndex] = {
          ...state.managers[managerIndex],
          blacklist: {
            ...state.managers[managerIndex].blacklist,
            rules: blacklist.rules,
          },
        };
      }
    },

    blacklistDeleteManagers: (state, action) => {
      const { blacklist } = action.payload;
      const managerIndex = state.managers.findIndex(
        (i) => i.managerId === blacklist?.managerId
      );
      if (managerIndex !== -1) {
        state.managers[managerIndex] = {
          ...state.managers[managerIndex],
          blacklist: {
            ...state.managers[managerIndex].blacklist,
            rules: [],
          },
        };
      }
    },
  },
});

export const {
  setManagers,
  setManagersLoading,
  setManagersError,
  clearManagersError,
  updateManagerSMAs,
  blacklistRulesManager,
  blacklistRulesModifiedManager,
  blacklistDeleteManagers,
} = managersSlice.actions;

// Selectors - Direct access to managers state
export const selectManagers = (state) => state.managers?.managers || [];
export const selectManagersLoading = (state) => state.managers?.loading || false;
export const selectManagersError = (state) => state.managers?.error || null;

export default managersSlice.reducer;

